/* Inspired by mantine use-os hook
  https://github.com/mantinedev/mantine/blob/master/packages/%40mantine/hooks/src/use-os/use-os.ts
*/
import { useEffect, useState } from "react";
export type OS =
  | "undetermined"
  | "macos"
  | "ios"
  | "windows"
  | "android"
  | "linux";


/* OS REGEX HELPERS */
const isMacOS = (userAgent: string): boolean => {
  const macosPattern = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;

  return macosPattern.test(userAgent);
};

const isIOS = (userAgent: string): boolean => {
  const iosPattern = /(iPhone)|(iPad)|(iPod)/i;

  return iosPattern.test(userAgent);
};

const isWindows = (userAgent: string): boolean => {
  const windowsPattern = /(Win32)|(Win64)|(Windows)|(WinCE)/i;

  return windowsPattern.test(userAgent);
};

const isAndroid = (userAgent: string): boolean => {
  const androidPattern = /Android/i;

  return androidPattern.test(userAgent);
};

const isLinux = (userAgent: string): boolean => {
  const linuxPattern = /Linux/i;

  return linuxPattern.test(userAgent);
};

/* OS CHECK UTIL */
const getOS = (): OS => {
  if (typeof window === "undefined") {
    return "undetermined";
  }

  const { userAgent } = window.navigator;

  if (isIOS(userAgent)) {
    return "ios";
  }
  if (isMacOS(userAgent)) {
    return "macos";
  }
  if (isWindows(userAgent)) {
    return "windows";
  }
  if (isAndroid(userAgent)) {
    return "android";
  }
  if (isLinux(userAgent)) {
    return "linux";
  }

  return "undetermined";
};

/* HOOK */
export const useOS = (): OS => {
  const [os, setOS] = useState<OS>(getOS());

  useEffect(() => {
    setOS(getOS());
  }, []);

  return os;
};
